export const UseCaseGroupEnum = {
  MARKETING: 'MARKETING',
  SALES: 'SALES',
  SERVICE: 'SERVICE',
  COMMERCE: 'COMMERCE',
  CONTENT: 'CONTENT',
  DATA: 'DATA',
  SMART_CRM: 'SMART_CRM'
};
export const HandledUseCaseGroups = Object.values(UseCaseGroupEnum);
export const useCasesQueryParamKey = 'useCaseGroups';